var _circle, _path, _rect, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoMatchingResultsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "#E6E4FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.701 6.25C15.2783 5.25 16.7217 5.25 17.299 6.25L25.0933 19.75C25.6706 20.75 24.9489 22 23.7942 22H8.20577C7.05107 22 6.32938 20.75 6.90673 19.75L14.701 6.25Z",
    fill: "#5A52C3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.9557,
    y: 12.9557,
    width: 1.78864,
    height: 6.08864,
    fill: "#E6E4FF",
    stroke: "#E6E4FF",
    strokeWidth: 0.0886364
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.9,
    cy: 10.9,
    r: 0.984109,
    fill: "#E6E4FF",
    stroke: "#E6E4FF",
    strokeWidth: 0.168218
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMatchingResultsIcon);
export default __webpack_public_path__ + "static/media/noMatchingResultsIcon.de8967788d9065b48c4f23a256732623.svg";
export { ForwardRef as ReactComponent };